import { SearchResultData } from "../../app/slices/SearchResultsSlice";
import { InteractionFactoryEntity } from "../../features/interaction_factory/InteractionFactory";
import ClickIndicatorPreview from "../../features/previews/click_indicator/ClickIndicatorPreview";
import ClickIndicatorNodePreview from "../../features/sequence/node_previews/ClickIndicatorNodePreview";
import { GetNewGuid } from "../../helpers/GuidHelper";
import { Actor } from "../Actor";
import Take from "../Take";
import Interaction, { InteractionType } from "./Interaction";
import {
  compactSearchableStrings,
  SearchLookupContext,
} from "./SearchableInteractionValues";

export const clickIndicatorStyles: string[] = [
  "Object",
  "Door",
  "Person",
  "Event",
  "Evac",
  "Finger",
  "Feet",
];

export interface IClickIndicator extends Interaction {
  propGuid: string;
  tag: string;
  style: string;
}

export const clickIndicatorInteraction = (): InteractionFactoryEntity => {
  const view = <ClickIndicatorPreview />;

  const create = (): IClickIndicator => {
    return {
      id: GetNewGuid(),
      name: "Click Indicator",
      type: InteractionType.ClickIndicator,
      propGuid: "",
      tag: "",
      style: clickIndicatorStyles[0],
      properties: [],
    };
  };

  const migrate = (
    from: number,
    to: number,
    interaction: Interaction
  ): IClickIndicator => {
    return interaction as IClickIndicator;
  };

  const copy = (
    interaction: Interaction,
    getKeys: (amount: number) => string[],
    replaceKey: (from: string, to: string) => void
  ): IClickIndicator => {
    const original = interaction as IClickIndicator;

    return {
      ...original,
      id: GetNewGuid(),
      properties: original.properties?.map((property) => ({ ...property })) ?? [],
    };
  };

  const validate = (
    interaction: Interaction,
    getValue: (key: string) => string,
    take: Take,
    actorPresets: Actor[]
  ): string[] => {
    const converted = interaction as IClickIndicator;
    const warnings: string[] = [];

    return warnings;
  };

  const filter = (
    interaction: Interaction,
    takeName: string,
    getMatchingResults: (
      searchableStrings: string[],
      takeName: string,
      interaction: Interaction,
      filterType: string
    ) => SearchResultData[],
    _getValue: (key: string) => string,
    searchLookupContext?: SearchLookupContext,
  ): SearchResultData[] => {
    const converted = interaction as IClickIndicator;
    const searchableStrings = compactSearchableStrings(
      converted.name,
      searchLookupContext?.getPropSearchTerms(converted.propGuid) ??
        converted.propGuid,
      converted.tag,
      converted.style,
    );

    return getMatchingResults(
      searchableStrings,
      takeName,
      interaction,
      filterType
    );
  };

  const filterType: string = "Click Indicator";

  const validateError = (
    interaction: Interaction,
    parentTake: Take,
    currentTake: Take,
    actorPresets: Actor[]
  ): string[] => {
    const converted = interaction as IClickIndicator;
    const errors: string[] = [];

    if (!converted.propGuid || converted.propGuid === "") {
      errors.push("No prop selected.");
    }

    return errors;
  };

  return {
    View: view,
    NodeView: (nodeId: string, interaction: Interaction) => (
      <ClickIndicatorNodePreview nodeId={nodeId} interaction={interaction} />
    ),
    FilterType: filterType,
    Create: create,
    Migrate: migrate,
    Copy: copy,
    Validate: validate,
    Filter: filter,
    ValidateErrors: validateError,
  };
};
